import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { enabledLocales, DEFAULT_LOCALE, AUTH_OPTIMIZELY_EXPERIMENT_ID } from "../../lib/contentful/types";
import { defaults, getTexts } from "../../lib/contentful/defaultTexts";
import { getContentfulData } from "../../lib/contentful";
import { getOptimizelyClient } from "../../lib/optimizely/optimizley";
import Cookies from 'js-cookie';
export function useGetContent(locale, optimizelyClientReceived) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    content = _useState2[0],
    setContent = _useState2[1];
  useEffect(function () {
    Promise.race([new Promise(function (resolve) {
      return setTimeout(resolve, 7000);
    }), getContentfulData({
      content_type: 'lean_component',
      'fields.internalName': 'OneAuthPage',
      locale: enabledLocales.includes(locale) ? locale : DEFAULT_LOCALE,
      include: 10
    })]).then(function (data) {
      if (!data) {
        console.info('contentful timeout return default texts');
      } else {
        // console.log('extracting contentful data');
        var optimizelyClient = optimizelyClientReceived || getOptimizelyClient();
        extractData(data, locale, optimizelyClient);
      }
      setContent(getTexts());
    })["catch"](function (e) {
      console.error(e);
      setContent(getTexts());
    });
  }, [locale, optimizelyClientReceived]);
  return content;
}
function extractData(data, locale, optimizelyClient) {
  var items = data.items;
  // in case the queried component doesn't exists
  if (!items.length) {
    return;
  }
  var forcedOFSParams = [];
  if (!forcedOFSParams && window.location.search.includes('force-exp-')) {
    var _forcedOFSParams;
    var ofsParams = getForcedOfsParams();
    forcedOFSParams = ofsParams;
    if ((_forcedOFSParams = forcedOFSParams) !== null && _forcedOFSParams !== void 0 && _forcedOFSParams.length) {
      var forcedOFSParamsObject = hasForcedOfsParams(forcedOFSParams, AUTH_OPTIMIZELY_EXPERIMENT_ID);
      if (Object.keys(forcedOFSParamsObject).length) {
        var userId = Cookies.get('CVID') || null;
        forceSetOptimizely(optimizelyClient, forcedOFSParamsObject, userId);
      }
    }
  }
  var components = items[0].fields.components;

  // in case component exists but has no child components
  if (!components) {
    return;
  }
  components.forEach(function (component) {
    var _component$fields, _component$fields2, _component$fields3;
    // here this checks that if variation container is present at "Component Level" in contentful
    // data structure, then call "extractContentfulVariationData" method to fetch component
    // from inside variatiopn container, otherwise use "plain" component and store in componentToBeProcessed.
    var componentToBeProcessed = component !== null && component !== void 0 && (_component$fields = component.fields) !== null && _component$fields !== void 0 && (_component$fields = _component$fields.variations) !== null && _component$fields !== void 0 && _component$fields.length && component !== null && component !== void 0 && (_component$fields2 = component.fields) !== null && _component$fields2 !== void 0 && _component$fields2.experimentId && component !== null && component !== void 0 && (_component$fields3 = component.fields) !== null && _component$fields3 !== void 0 && _component$fields3.experimentKey ? extractContentfulVariationData(component, locale, optimizelyClient) : component;
    var componentId = componentToBeProcessed.fields.id;
    var textComponents = componentToBeProcessed.fields.components;
    populateDataSet(textComponents, componentId, locale, optimizelyClient);
  });
}
function populateDataSet(textComponents, componentId, locale, optimizelyClient) {
  textComponents === null || textComponents === void 0 || textComponents.forEach(function (textComp) {
    var _textComp$fields;
    var componentToBeProcessed = textComp !== null && textComp !== void 0 && (_textComp$fields = textComp.fields) !== null && _textComp$fields !== void 0 && (_textComp$fields = _textComp$fields.variations) !== null && _textComp$fields !== void 0 && _textComp$fields.length && textComp.fields.experimentTitle && textComp.fields.experimentKey ? extractContentfulVariationData(textComp, locale, optimizelyClient) : textComp;
    var textId = componentToBeProcessed.fields.id;
    // use the translated value or fallback to default string in english
    var value = componentToBeProcessed.fields.value || defaults[componentId][textId];
    getTexts()[componentId][textId] = value;
  });
}
function extractContentfulVariationData(textComp, locale, optimizelyClient) {
  var _textComp$fields2, _textComp$fields3;
  // This function pulls out data from variation containers (if present in contentful response).
  var variationArray = (textComp === null || textComp === void 0 || (_textComp$fields2 = textComp.fields) === null || _textComp$fields2 === void 0 ? void 0 : _textComp$fields2.variations) || [];
  // Calling optimizely in cass of string vs stirng scenarion with EXPERIMENT KEY received from contenful data.
  var optimizelyResponse = activateOptimizely(textComp.fields.experimentKey, locale, optimizelyClient);
  var decidedVariationId = textComp === null || textComp === void 0 || (_textComp$fields3 = textComp.fields) === null || _textComp$fields3 === void 0 || (_textComp$fields3 = _textComp$fields3.meta) === null || _textComp$fields3 === void 0 ? void 0 : _textComp$fields3[optimizelyResponse];
  // @ts-ignore
  var decidedVariationObject = variationArray.find(function (obj) {
    var id = obj.sys.id;
    if (id === decidedVariationId) {
      return obj;
    }
  });
  return decidedVariationObject;
}
function activateOptimizely(EXPERIMENT_KEY, locale, optimizelyClient) {
  // here we check whether optimizely client  is passed as prop from auth page or this file is creating it's locaL optimizely client.
  var userId = Cookies.get('CVID') || null;
  var variation = optimizelyClient.activate(EXPERIMENT_KEY, userId, {
    browser_language: locale || DEFAULT_LOCALE // check audience
  });
  return variation;
}
function getForcedOfsParams() {
  // fetch all params related to force Optimizely i.e. "force-exp-{experimentId}=variationId" from url.
  var forceRegex = /^force-exp-([\w-]+)$/;
  var paramsList = window.location.search.slice(1).split('&');
  var forcedOfsParamsList = [];
  for (var param in paramsList) {
    if (paramsList[param].includes('force-exp-')) {
      var paramValue = paramsList[param].split('='); // sperating key and value i.e. "force-exp-{experimentId}=variationId" into ['force-exp-{experimentId}' and 'variationId']
      if (forceRegex.test(paramValue[0])) {
        var forcedParamsObj = {
          experimentId: paramValue[0].slice(10),
          // removing 'force-exp-' from [force-exp-{experimentId} i.e. force-exp-landing_page_hero_image], to get experiment id.
          variationId: paramValue[1]
        };
        forcedOfsParamsList.push(forcedParamsObj);
      }
    }
  }
  return forcedOfsParamsList;
}
function hasForcedOfsParams(forcedOFSParams, ofsExperimentId) {
  // return matching experimentId and variationId as an object.
  var optimizelyURLData = {}; // stores expermentId and VariationId passed as query param in url.
  forcedOFSParams.forEach(function (paramsObj) {
    if (paramsObj.experimentId === ofsExperimentId) {
      optimizelyURLData = paramsObj;
    }
  });
  return optimizelyURLData;
}

// This fn is used to call force optimizely method with the passed experimentId and variationId in url.
function forceSetOptimizely(optimizelyClient, forcedParamsObj, userId) {
  var _optimizelyClient$get;
  var experimentId = forcedParamsObj.experimentId,
    variationId = forcedParamsObj.variationId;
  var experimentsMap = (_optimizelyClient$get = optimizelyClient.getOptimizelyConfig()) === null || _optimizelyClient$get === void 0 ? void 0 : _optimizelyClient$get.experimentsMap;
  // @ts-ignore
  var experiment = experimentsMap[experimentId];
  if (!experiment) return;
  var variationKeys = Object.keys(experiment.variationsMap);
  if (variationKeys.includes(variationId)) optimizelyClient.setForcedVariation(experimentId, userId, variationId);
}